import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShoppingcartService } from '../../../shoppingcart/shoppingcart.service';
import { DeleteAccountRequest } from '../deleteaccountrequest';
import { DeleteAccountResponse } from '../deleteaccountresponse';
import { ApiRequestService } from '../../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../../toastmessage/toastmessage.service';



@Component({
    selector: 'pw-deleteaccountpopup',
    templateUrl: './deleteaccountpopup.component.html',
    styleUrls: ['./deleteaccountpopup.component.scss']
})
export class DeleteAccountPopupComponent {
    selectedAlign: 'start' | 'center' | 'end';

    deleteAccountRequest?:DeleteAccountRequest = {};

    deleteAccountUrl = '/delete-account';

    authBackendUrl = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public email:string,
        private _dialog: MatDialog,
        @Inject('AUTH_BACKEND_URL') private _authBackendUrl: string,
        private _apiRequestService: ApiRequestService,
        private _router: Router,
        private _toastMessageService:ToastmessageService
    ) {
        this.selectedAlign = 'end';
        this.authBackendUrl = _authBackendUrl;

    }

    closeDialog() {
        this._dialog.closeAll();
    }

    deleteAccount() {
        this.deleteAccountRequest = {
            email:this.email
        }
        this._apiRequestService
        .sendRequest<DeleteAccountRequest | undefined, DeleteAccountResponse>(this.authBackendUrl, true, this.deleteAccountRequest, true, this.deleteAccountUrl)
        .subscribe((answer) => {
            sessionStorage.clear();
            this._toastMessageService.displayToastMessage(TOAST_STATE.success, answer.message!,MAT_ICON.success);
            this.dismissError();
            this._router.navigateByUrl('/');
            this.closeDialog();

        });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
